import { IDeal } from '@interfaces/deal';
import { CURRENCY } from '@constants/common.constants';
import { roundPrice } from '@helpers/deal.helper';

interface IDealPriceProps {
	data: IDeal;
	isSmall?: boolean;
}

export default function DealPrice({ data, isSmall = false }: IDealPriceProps) {
	return (
		<div>
			<div className={`text-orange font-semibold ${isSmall ? 'text-lg leading-[20px] mb-1' : 'text-2xl'}`}>
				{data?.merchant?.acceptedCurrencyCode || CURRENCY.SGD} {roundPrice(data?.sellingPrice || 0)}
			</div>
			<div className={`flex font-semibold text-blue-grey leading-[18px] ${isSmall ? 'mb-[10px]' : 'text-[18px]'}`}>
				<div className='mr-0.5'>{data?.merchant?.acceptedCurrencyCode || CURRENCY.SGD}</div>
				<span className='line-through mr-1'>{roundPrice(data?.originalPrice || 0)}</span>
				<div className='flex items-center bg-orange p-0.5 text-white font-bold rounded text-sm align-center leading-[14px]'>
					-{data?.estimatedSavings || 0}%
				</div>
			</div>
		</div>
	);
}
